import { z } from "zod";
import { EventAttendeeStatus, EventAudienceFilter, EventTimeFilter } from "../enum.js";

export const eventListQuerySchema = z
	.object({
		tab: z.enum(EventAudienceFilter).default(EventAudienceFilter.ALL),
		filter: z.enum(EventTimeFilter).default(EventTimeFilter.UPCOMING),
		cursor: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).default(20),
	})
	.strict();

export type EventListQueryPayload = z.infer<typeof eventListQuerySchema>;

export const eventDatesQuerySchema = z
	.object({
		year: z.coerce.number().int().min(2020).max(2100),
		month: z.coerce.number().int().min(1).max(12),
	})
	.strict();

export type EventDatesQueryPayload = z.infer<typeof eventDatesQuerySchema>;

export const eventAttendeesQuerySchema = z
	.object({
		status: z.enum(EventAttendeeStatus).optional(),
	})
	.strict();

export type EventAttendeesQueryPayload = z.infer<typeof eventAttendeesQuerySchema>;
